import { useEffect, useState } from 'react';
import  {ApiService} from "../../api/ProjectInfoService";
import {
  TabList,
  Tab,
  SelectTabEvent,
  SelectTabData,
  TabValue,
  Spinner,
} from "@fluentui/react-components";
import "./global.scss";
import AlgemeenBox from "../AlgemeenTab/AlgemeenBox";
import TalenBox from "../AlgemeenTab/TalenBox";
import PlanningBox from "../AlgemeenTab/PlanningBox";
import HoofdfinancierderBox from "../AlgemeenTab/HoofdfinancierderBox";
import LedenBox from "../LedenTab/LedenBox";
import FinanceBox from "../FinanceTab/FinanceBox";

import React from "react";
import MijlpalenBox from "../MijlpabelTab/MijlpalenBox";
import AanvragerBox from "../AlgemeenTab/AanvragerBox";
import ResourcePlanningBox from "../ResourcePlanningTab/ResourcePlanningBox";
import ResearchTeamsBox from "../KennisGroepenTab/ResearchTeamsBox";
import PartnerBox from "../PartnerTab/PartnerBox";
import WerkveldBox from "../WerkveldTab/WerkveldBox";
import ThemaBox from "../ThemaTab/ThemaBox";
import ExternalIDBox from "../IDTab/ExternalIDBox";
import { app } from "@microsoft/teams-js";
import BestandenBox from "../BestandenTab/BestandenBox";
import { Button } from '@mui/joy';


export function Home() {
  const[email, setEmail] = useState<string>("");
  const [projectName, setProjectName] = useState<string>("");
  const [selectedValue, setSelectedValue] = useState<TabValue>("local");
  const [project, setProject] = useState<any>(null);
  const [userIsPrivileged, setUserIsPrivileged] = useState<boolean>(false);

  if(app.isInitialized()) {

    app.getContext().then((context : any) => {
      setUserIsPrivileged(isUserPrivileged(context?.user));
      const email = context.user?.loginHint;
      setEmail(email!);
      const team = context.sharePointSite?.teamSitePath;
        const projectName = team?.replace("/sites/", "").replace("-02.Opvolgen", "").replace("-Opvolgen", "").replace("-FollowUp", "").replace("-02.FollowUp", "");//team?.match(new RegExp("^\D.+?(\d+)"));
      setProjectName(projectName!);
      
  });
}

  const onTabSelect = (event: SelectTabEvent, data: SelectTabData) => {
    setSelectedValue(data.value);
  };

  const isUserPrivileged = (currentUser : any) : boolean => {
    if (!currentUser) return false;
    const member = project?.stakeholders?.models.find( (member: any) => member.o365Login === currentUser?.loginHint);
    if (member?.relation?.roleType === "G3"){
       return true;
    }
     return false;
  }

  const refresh = () => {

    setProject(null);

    if (!project)
      return (
        <div className="loadingCircle">
          <Spinner size="extra-large" label="Project Informatie laden..." labelPosition="below" />
        </div>
      );

      ApiService.getProjectData(projectName).then((response: any) => {
        setProject(response.data);
    });
  }
  
   
  
  
  useEffect(() => {
    // Create function in seperta file
    if (!projectName) return;
    ApiService.getProjectData(projectName).then((response: any) => {
      setProject(response.data);
    });
  }, [projectName]);

  if (!project)
    return (
      <div className="loadingCircle">
        <Spinner
          size="extra-large"
          label={!projectName ? "Teams omgeving laden..." : "Project Informatie laden..."}
          labelPosition="below"
        />
      </div>
    );

  return (
    <div className="project-info-container">
      <div className="project-info-header">
        <TabList selectedValue={selectedValue} onTabSelect={onTabSelect}>
          <Tab id="Local" value="local">Algemeen</Tab>
          <Tab id="Leden" value="leden">Leden</Tab>
          {userIsPrivileged && <Tab id="Financien" value="finance">Financiën</Tab>}
          {userIsPrivileged && <Tab id="ResourcePlanning" value="resourceplanning">Resourceplanning</Tab>}
          <Tab id="Mijlpalen" value="mijlpalen">Mijlpalen</Tab>
          <Tab id="KennisGroepen" value="kennisgroepen">Kennisgroepen</Tab>
          <Tab id="Partners" value="partners">Partners</Tab>
          <Tab id="Werkveld" value="werkveld">Werkveld</Tab>
          <Tab id="bestanden" value="bestanden">Bestanden</Tab>
          <Tab id="thema" value="thema">Thema's</Tab>
          <Tab id="ID" value="id">ID's</Tab>
        </TabList>
        <Button
          className="headerButton"
          variant="outlined"
          color="neutral"
          onClick={() => refresh()}
        >
          Refresh
        </Button>
      </div>
      <div className="project-info-content">
        {selectedValue === "local" && (
          <div className="tab">
            <div className="generalBoxes">
              <AlgemeenBox title={"Algemeen"} project={project} userIsPrivileged={true} />
              <PlanningBox title={"Planning"} project={project} />
              <AanvragerBox title="Aanvrager" project={project} />
              <HoofdfinancierderBox title="Hoofdfinancier" project={project} />
            </div>
            <div className="langBoxes">
              <TalenBox language="nl" title={"Nederlands"} project={project} userIsPrivileged={true} />
              <TalenBox language="en" title={"Engels"} project={project} userIsPrivileged={true} />
              <TalenBox language="fr" title={"Frans"} project={project} userIsPrivileged={true} />
            </div>
          </div>
        )}
        {selectedValue === "leden" && (
          <div className="tab">
            <LedenBox title={"Leden"} data={project?.stakeholders?.models} email={email} dospId={project?.dospId} userIsPrivileged={true} />
          </div>
        )}
        {selectedValue === "finance" && userIsPrivileged && (
          <div className="fw">
            <FinanceBox title={"Financiën"} project={project} />
          </div>
        )}
        {selectedValue === "resourceplanning" && userIsPrivileged && (
          <div className="tab">
            <ResourcePlanningBox
              title={"Resourceplanning"}
              project={project?.workpercentages?.models}
            />
          </div>
        )}
        {selectedValue === "kennisgroepen" && (
          <div className="tab">
            <ResearchTeamsBox title={"Kennisgroepen"} project={project} />
          </div>
        )}
        {selectedValue === "partners" && (
          <div className="tab">
            <PartnerBox title={"Partners"} project={project} email={email} dospId={project?.dospId} userIsPrivileged={true} />
          </div>
        )}
        {selectedValue === "werkveld" && (
          <div className="tab">
            <WerkveldBox title={"Werkveld"} project={project} />
          </div>
        )}
        {selectedValue === "thema" && (
          <div className="themaTab">
            <ThemaBox title="Discipline codes" project={project} email={email} userIsPrivileged={true} />
          </div>
        )}
        {selectedValue === "id" && (
          <div className="tab">
            <ExternalIDBox title="ID's" project={project} />
          </div>
        )}
        {selectedValue === "bestanden" && (
          <div className="tab">
            <BestandenBox title="Bestanden" project={project} />
          </div>
        )}
        {selectedValue === "mijlpalen" && (
          <div className="tab">
            <MijlpalenBox title="Mijlpalen" project={project} />
          </div>
        )}
      </div>
    </div>
  );
}
